export const TIPO_PERSONA_OPTIONS = [
  { value: "moral", label: "Persona moral" },
  { value: "fisica", label: "Persona física" },
];

export function emptyClientMasterForm() {
  return {
    rfc: "",
    razon_social: "",
    nombre_comercial: "",
    tipo_persona: "",
    email_principal: "",
    telefono: "",
    whatsapp_principal: "",
    contacto_principal: "",
    contacto_contable: "",
    acepta_recordatorios: false,
    acepta_whatsapp: false,
    despacho_config: {
      auxiliar_asignado: "",
      honorario_mensual: "",
      dia_cobro: "",
      servicios_recurrentes: [],
      recordatorios_enabled: false,
    },
  };
}

export function masterToForm(row) {
  const despachoLink = (row?.module_links || []).find((l) => l.module_id === "despacho");
  const cfg = despachoLink?.module_config || {};
  return {
    rfc: row?.rfc || "",
    razon_social: row?.razon_social || "",
    nombre_comercial: row?.nombre_comercial || "",
    tipo_persona: row?.tipo_persona || "",
    email_principal: row?.email_principal || "",
    telefono: row?.telefono || "",
    whatsapp_principal: row?.whatsapp_principal || "",
    contacto_principal: row?.contacto_principal || "",
    contacto_contable: row?.contacto_contable || "",
    acepta_recordatorios: Boolean(row?.acepta_recordatorios),
    acepta_whatsapp: Boolean(row?.acepta_whatsapp),
    despacho_config: {
      auxiliar_asignado: cfg.auxiliar_asignado || "",
      honorario_mensual: cfg.honorario_mensual ?? "",
      dia_cobro: cfg.dia_cobro ?? "",
      servicios_recurrentes: Array.isArray(cfg.servicios_recurrentes) ? cfg.servicios_recurrentes : [],
      recordatorios_enabled: Boolean(cfg.recordatorios_enabled),
    },
  };
}

export function formToCreatePayload(form) {
  const honorario = form.despacho_config?.honorario_mensual;
  const diaCobro = form.despacho_config?.dia_cobro;
  return {
    rfc: form.rfc || "",
    razon_social: form.razon_social,
    nombre_comercial: form.nombre_comercial || "",
    tipo_persona: form.tipo_persona || "",
    email_principal: form.email_principal || "",
    telefono: form.telefono || "",
    whatsapp_principal: form.whatsapp_principal || "",
    contacto_principal: form.contacto_principal || "",
    contacto_contable: form.contacto_contable || "",
    acepta_recordatorios: Boolean(form.acepta_recordatorios),
    acepta_whatsapp: Boolean(form.acepta_whatsapp),
    module: "despacho",
    despacho_config: {
      auxiliar_asignado: form.despacho_config?.auxiliar_asignado || null,
      honorario_mensual: honorario === "" || honorario == null ? null : Number(honorario),
      dia_cobro: diaCobro === "" || diaCobro == null ? null : Number(diaCobro),
      servicios_recurrentes: form.despacho_config?.servicios_recurrentes || [],
      recordatorios_enabled: Boolean(form.despacho_config?.recordatorios_enabled),
    },
  };
}

export function formToUpdatePayload(form) {
  const base = formToCreatePayload(form);
  delete base.module;
  return base;
}

export function linkedModulesLabel(row) {
  const links = row?.module_links || [];
  if (!links.length) return "—";
  return links.map((l) => l.module_id).join(", ");
}
